import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/components-styles/question-components-styles/RecentSessions.css";

const RecentSessions = ({ userId }) => {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                console.log("Fetching recent answered questions...");
                const response = await axios.get(`/user/recent-answered-questions/${userId}`);
                console.log("Fetch successful:", response.data);

                console.log("Response data:", response.data);
                if (response.data && Array.isArray(response.data.formatted)) {
                    setSessions(response.data.formatted);
                } else {
                    alert("Unexpected response format.");
                    console.warn("Unexpected response:", response.data);
                }

            } catch (error) {
                alert("Error fetching recent questions. Please try again later.");
                console.error("Fetch error:", error);
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchSessions();
        } else {
            console.warn("No userId provided to RecentSessions component.");
        }
    }, [userId]);

    return (
        <div className="recent-sessions-container">
            <div className="recent-sessions-header">RECENT SESSIONS</div>
            {loading ? (
                <div className="loading-text">Loading...</div>
            ) : (
                <div className="sessions-list">
                    {sessions && sessions.length > 0 ? (
                        sessions.map((session) => (
                            <div key={session.id} className="session-item">
                                <div><strong>ID:</strong> {session.id}</div>
                                <div><strong>Question:</strong> {session.questionText}</div>
                                <div>
                                    <strong>Status:</strong>{" "}
                                    <span className={session.isCorrect ? "correct" : "incorrect"}>
                                        {session.isCorrect ? "Correct" : "Incorrect"}
                                    </span>
                                </div>
                                <div><strong>Your Answer:</strong> {session.userAnswer}</div>
                                <div>
                                    <strong>Attempted At:</strong>{" "}
                                    {new Date(session.attemptedAt).toLocaleString()}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div>No recent sessions found.</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default RecentSessions;
